/*
* @prop --uic-combobox-max-width: The maximum width of the combobox.
* @prop --uic-list-popover-max-height: The maximum height of the list.
* @prop --uic-list-popover-max-width: The maximum width of the list.
* @prop --uic-list-popover-width: The width of the list.
* @prop --uic-combobox-max-width: The maximum width of the list.
*/

uic-combobox {
    display: inline-block;
    box-sizing: border-box;
    position: relative;

    max-width: var(--uic-combobox-max-width);
}

.uic-combobox {
    &__wrapper {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
    }

    &__filter {
        width: 100%;
    }

    &__toggle {
        padding-left: 0;
        margin-left: -4px;
    }

    &__filter-message {
        @include font(medium);
        box-sizing: border-box;
        display: none;
        color: var(--uic-color-grey3a50);
        min-height: 64px;
        padding: 12px 8px;
        align-items: center;
    }

    &__toggle {
        --uic-icon-width: var(--uic-icon-dimensions-default);
        --uic-icon-height: var(--uic-icon-dimensions-default);
    }

    &__toggle-icon {
        width: 100%;
        height: 100%;
    }

    &__scrollpanel {
        max-height: var(--uic-list-popover-max-height);
        max-width: var(--uic-list-popover-max-width);
        width: var(--uic-list-popover-width, auto);
    }

    &--open &__toggle-icon > svg {
        transform: rotate(180deg);
    }

    &--no-results &__filter-message {
        display: flex;
    }

    &--disabled {
        pointer-events: none;
    }

    &--invalid {
        .uic-combobox__helper-text {
            color: var(--uic-color-red1);
        }
    }

    &.uic-combobox--has-helper-text {
        .uic-combobox__helper-text {
            margin-top: -5px;
            padding: 0 8px;
        }
    }

    &__helper-text {
        overflow: hidden;
        color: var(--uic-color-black);
        font-size: 0.8rem;
        line-height: 1.3rem;
        text-overflow: ellipsis;

        &-inner {
            @include truncate();
        }
    }

    .uic-input-field {
        padding-top: 2px;

        > label {
            margin-right: calc(-1 * (4px + var(--uic-stretched-button-width)));
        }
    }
}
